import {useEffect, useState} from "react";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { conditions, videoTag } from "helpers";
import { ConditionName } from "interfaces";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover, setSharePopover } from "redux-share/slices/popoversSlice";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const ShareDialog = dynamic(() => import("../share/shareDialog"));
const TagsPopover = dynamic(() => import("../tags/tagsPopover"));
const BookmarksPopover = dynamic(() => import("../bookmark/bookmarksPopover"));
const TrailerPopover = dynamic(() => import("../trailer/trailerPopover/trailerPopover"));
const LoginPopover = dynamic(() => import("../login/loginPopover"));
const PreFactorPopover = dynamic(() => import("../cinemaHamrahPopovers/preFactorPopover"));

const Popovers = () => {

    const [videoCurrentTime, setVideoCurrentTime] = useState<number>(0);

    const dispatch = useAppDispatch();
    const { sharePopover } = useAppSelector(({ popovers: { sharePopover } }) => ({ sharePopover }), shallowEqual);
    useAppSelector(({ videoData: { isComplexDesktop } }) => ({ isComplexDesktop }), shallowEqual);

    useEffect(() => {
        if (sharePopover) {
            if (!conditions(ConditionName.isComplexDesktop)) dispatch(setActiveElements(false));
            dispatch(setSettingPopover(false));
            setVideoCurrentTime(videoTag().currentTime);
        }
    }, [sharePopover])

    return (
        <>
            {!conditions(ConditionName.isStaticFormat) && (
                <>
                    <ShareDialog currentTime={videoCurrentTime} status={sharePopover} onClose={() => dispatch(setSharePopover(false))} />
                    <TagsPopover />
                    <BookmarksPopover />
                    <TrailerPopover />
                    <LoginPopover />
                    <PreFactorPopover />
                </>
            )}
        </>
    )
}

export default Popovers;